import BrazilStatesJson from '../../components/assets/BrazilStates.json'
import CanadianProvincesJson from '../../components/assets/CanadianProvinces.json'
import PortugalDistrictsJson from '../../components/assets/PortugalDistricts.json'
import SpainAutonomousCommunitiesJson from '../../components/assets/SpainAutonomousCommunities.json'
import USAStatesJson from '../../components/assets/USAStates.json'
import i18n from '../../locales/i18n'
import { CountryCode } from '../../types'
import { createStatesMap } from '../../utils/regionUtils'

export const StateValues = {
  [CountryCode.US]: createStatesMap(USAStatesJson),
  [CountryCode.CA]: createStatesMap(CanadianProvincesJson),
  [CountryCode.ES]: createStatesMap(SpainAutonomousCommunitiesJson),
  [CountryCode.PT]: createStatesMap(PortugalDistrictsJson),
  [CountryCode.BR]: createStatesMap(BrazilStatesJson),
}

export const StateTitle = {
  [CountryCode.US]: i18n.t('Regions:TERRITORY.STATE'),
  [CountryCode.CA]: i18n.t('Regions:TERRITORY.PROVINCE'),
  [CountryCode.ES]: i18n.t('Regions:TERRITORY.AUTONOMOUS_COMMUNITY'),
  [CountryCode.PT]: i18n.t('Regions:TERRITORY.DISTRICT'),
  [CountryCode.BR]: i18n.t('Regions:TERRITORY.STATE'),
}
